import { render } from "./WarrantyStatus.vue?vue&type=template&id=dfb41712&ts=true"
import script from "./WarrantyStatus.vue?vue&type=script&lang=ts"
export * from "./WarrantyStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__